// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, doc, updateDoc, getDoc } from 'firebase/firestore/lite';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries, getDoc query, orderBy

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAwau71aWXQ6L8KvwZfHpELnzNq_n0GaPw",
    authDomain: "addariogiosue.firebaseapp.com",
    databaseURL: "https://addariogiosue.firebaseio.com",
    projectId: "addariogiosue",
    storageBucket: "addariogiosue.appspot.com",
    messagingSenderId: "151617649444",
    appId: "1:151617649444:web:bb1e207451cdd200ca91b1",
    measurementId: "G-YSLME4217P"
  };

// Initialize Firebase
initializeApp(firebaseConfig);



export async function numVisual() {
    let db = getFirestore();
    let query = await getDoc(doc(collection(db, "db"), "info"));
    if (query.exists()) {
        if (localStorage.getItem("numVisual") == null) {
            updateDoc(doc(collection(db, "db"), "info"), {
                numVisual: query.data().numVisual + 1,
            });
            localStorage.setItem("numVisual", "counted");

        }
        updateDoc(doc(collection(db, "db"), "info"), {
            numVisualTot: query.data().numVisualTot + 1,
        });
    }

}
/*
export function setdb(){
    const db = getFirestore();
    const dbLinea = collection(db, "gestione_navette")
    let arr = [
        { fermata:'Villeneuve - Scuole', orario_inizio_servizio:'9:00', orario_fine_servizio:'11:05'},
        { fermata:'Villeneuve - Entrata est cap', orario_inizio_servizio:'9:02', orario_fine_servizio:'11:07'},
        { fermata:'Introd - Junod', orario_inizio_servizio:'9:06', orario_fine_servizio:'11:11'},
        { fermata:'Introd - Villes Dessous', orario_inizio_servizio:'9:07', orario_fine_servizio:'11:12'},
        { fermata:'Introd - Villes Dessus', orario_inizio_servizio:'9:08', orario_fine_servizio:'11:13'},
        { fermata:'Introd - Norat', orario_inizio_servizio:'9:09', orario_fine_servizio:'11:14'},
        { fermata:'Introd - Introd Plan', orario_inizio_servizio:'9:10', orario_fine_servizio:'11:15'},
        { fermata:'Introd - Delliod', orario_inizio_servizio:'9:12', orario_fine_servizio:'11:17'},
        { fermata:'Introd - Buillet', orario_inizio_servizio:'9:14', orario_fine_servizio:'11:19'},
        { fermata:'Introd - Chevrères', orario_inizio_servizio:'9:19', orario_fine_servizio:'11:24'},
        { fermata:'Valsavarenche - Molère', orario_inizio_servizio:'9:22', orario_fine_servizio:'11:27'},
        { fermata:'Valsavarenche - Fenille', orario_inizio_servizio:'9:25', orario_fine_servizio:'11:30'},
        { fermata:'Valsavarenche - Bois de Clin', orario_inizio_servizio:'9:28', orario_fine_servizio:'11:33'},
        { fermata:'Valsavarenche - Rovenaud', orario_inizio_servizio:'9:31', orario_fine_servizio:'11:36'},
        { fermata:'Valsavarenche - Dégioz', orario_inizio_servizio:'9:35', orario_fine_servizio:'11:40'},
        { fermata:'Valsavarenche - Bien', orario_inizio_servizio:'9:39', orario_fine_servizio:'11:44'},
        { fermata:'Valsavarenche - Eaux Rousses', orario_inizio_servizio:'9:42', orario_fine_servizio:'11:47'},
        { fermata:'Valsavarenche - Pravieux', orario_inizio_servizio:'9:50', orario_fine_servizio:'11:55'},
        { fermata:'Valsavarenche - Rifugio Chabod', orario_inizio_servizio:'9:53', orario_fine_servizio:'11:58'},
        { fermata:'Valsavarenche - Pont Valsavarenche', orario_inizio_servizio:'9:55', orario_fine_servizio:'12:00'},
      ];
//      await setDoc(doc(getFirestore(), "fermate"), arr);
try{
    setDoc(doc(dbLinea, "linea-valsavarenche_villeneuve"),{'fermate':arr})
}
catch(error){
    console.log(error)
}
}*/
//https://firebase.google.com/docs/storage/web/download-files
/*export function storeImg(img, titolo, callback) {

    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.open('GET', img);
    xhr.send();
    xhr.onload = () => {
        if (callback) callback(xhr.response);

    };

}*/